export default __webpack_public_path__ + "static/wallpaper-6-pc-a2dac8bc6f9a6b7bcbd95d107d03fcb3.png";